import type { BatchWorkspaceVersion, QuoteWorkspaceVersion } from 'state/userPreferences/userPreferences.model';
import type { TabsForWorkspace } from 'state/workspaces/model';

import { useBlockMetadata } from './useBlockMetadata';
import { useFieldMetadata } from './useFieldMetadata';

export function useFieldOrBlockHidden(
  id: string,
  workspaceType: keyof TabsForWorkspace | undefined,
  quoteWorkspaceVersion: QuoteWorkspaceVersion,
  batchWorkspaceVersion: BatchWorkspaceVersion,
  mustForceAdvancedMode: boolean,
): boolean {
  const blockMetadata = useBlockMetadata(id);
  const fieldMetadata = useFieldMetadata(id);

  if (
    workspaceType === 'newBatch' &&
    batchWorkspaceVersion === 'Standard' &&
    (blockMetadata ?? fieldMetadata)?.isForAdvancedModeForBatch === true &&
    mustForceAdvancedMode !== true
  ) {
    return true;
  }

  if (
    quoteWorkspaceVersion === 'Standard' &&
    (blockMetadata ?? fieldMetadata)?.isForAdvancedMode === true &&
    mustForceAdvancedMode !== true
  ) {
    return true;
  }

  return (blockMetadata ?? fieldMetadata)?.isHidden ?? false;
}
